var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427320173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 438",
    d: "M19 0.118164C13.9609 0.118164 9.12816 2.11994 5.56497 5.68313C2.00178 9.24633 4.40533e-07 14.079 0 19.1182C-4.40533e-07 24.1573 2.00178 28.99 5.56497 32.5532C9.12816 36.1164 13.9609 38.1182 19 38.1182L19 19.1182L19 0.118164Z",
    fill: "url(#paint0_linear_1311_77682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 439",
    opacity: 0.2,
    d: "M19 38.1182C24.0391 38.1182 28.8718 36.1164 32.435 32.5532C35.9982 28.99 38 24.1573 38 19.1182C38 14.0791 35.9982 9.24633 32.435 5.68314C28.8718 2.11995 24.0391 0.118167 19 0.118166L19 19.1182L19 38.1182Z",
    fill: "url(#paint1_linear_1311_77682)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1311_77682",
    x1: -5.57143,
    y1: -25.1114,
    x2: 57.1732,
    y2: -13.9106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27C69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C7BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1311_77682",
    x1: 43.5714,
    y1: 63.3477,
    x2: -19.1732,
    y2: 52.1469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27C69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C7BDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPlan);
export default __webpack_public_path__ + "static/media/basic_plan.d72734117035b2e52b051d3ab26dc0cc.svg";
export { ForwardRef as ReactComponent };